import BlogPostGrid from './BlogPostGrid';

export default BlogPostGrid;
